<template>
    <div class="relative">
        <input :required="isRequired" type="text" :name="inputName" class="form-input border rounded-full w-full selected:border-blue-800 border-gray-500
          disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300"
          autocomplete="off" v-model="state" @input="filterStates" @focus="modal = true">
        <div @click="getMunicipios()" class="cursor-pointer absolute flex justify-center items-center right-0 -translate-y-full bg-gray-100 h-[42px] w-[42px] rounded border border-l-0 border-gray-500">
            <Icon name="Pesquisar"/>
        </div>

        <div v-if="filteredStates && modal">
            <ul class="mt-2 p-0 m-0 overflow-auto border-2 border-gray-500 rounded border-b-0 max-h-[220px] noscroll">
                <li v-for="( filteredState,key ) in filteredStates" class="cursor-pointer hover:bg-[#2E59FF] hover:text-white text-black form-input w-full border-b-2 selected:border-blue-800
            disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300 border-gray-500"  :key="key" @click="setState(filteredState)">{{filteredState}}</li>
            </ul>
        </div>
    </div>
</template>
<script>

import Icon from "@/Components/UI/Icons/Icon.vue";
import axios from "axios";

export default {
    components: {
        Icon
    },
    props: {
        state: String,
        initialValue: String,
        inputName: String,
        isRequired: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            states: [],
            state: this.initialValue,
            modal: false,
            filteredStates: [],
            initialValue: String,
        }
    },
    mounted() {
        this.filterStates()
    },
    methods: {
        filterStates() {
            this.$emit('updateValue', this.state);
            if(this.state.length == 0) {
                this.filteredStates = this.state
            }
            this.filteredStates = this.states.filter(state => {
                return state.toLowerCase().startsWith(this.state.toLowerCase());
            })
        },
        setState(state) {
            this.state = state;
            this.$emit('updateValue', this.state);
            this.modal = false;
        },
        getMunicipios() {
            return axios
                .get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios?orderBy=nome')
                .then(res => res.data)
                .then(datas => datas.map(data => data.nome))
                .then(res => {
                    this.states = res;
                    this.filterStates();
                })
        },
    },

    watch: {
        state() {
            this.filterStates();
        }
    }
}
</script>
<style scoped>
    .noscroll::-webkit-scrollbar {
        display: none; /* Hide scrollbar for Chrome, Safari and Opera */
    }
    .noscroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
